var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ja-content',{attrs:{"pageTitle":_vm.pageTitle}},[(_vm.campaigns.length)?_c('ja-table',{attrs:{"items":_vm.campaigns,"pagination":_vm.pagination,"on-change-page":_vm.handleChangePage}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }